import { render, staticRenderFns } from "./DemoPage.vue?vue&type=template&id=a3c76742&scoped=true"
import script from "./DemoPage.vue?vue&type=script&lang=js"
export * from "./DemoPage.vue?vue&type=script&lang=js"
import style0 from "./DemoPage.vue?vue&type=style&index=0&id=a3c76742&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c76742",
  null
  
)

export default component.exports